import type { Catalog } from './types';
import { common } from './en/common';
import { paywall } from './en/paywall';
import { identity } from './en/identity';
import { checkout } from './en/checkout';
import { shell } from './en/shell';

// The English default catalog, compiled into the bundle. It is both the
// English rendering and the per-key fallback for every other locale, so a
// missing translation can never render blank. Keys are dotted and namespaced
// per area; values are flat templates with named `{vars}` or plural objects
// (see types.ts). The key-drift guard (i18n/catalog.test.ts) requires every
// shipped locale file to match this key set exactly, including `{placeholder}`
// sets per key.
export const en: Catalog = { ...common, ...paywall, ...identity, ...checkout, ...shell };

// enFlat reads a flat (non-plural) English entry for the preview bundle's
// edit-normalization constants, which must stay English and string-typed
// regardless of catalog state. Throws on a missing or plural key so a catalog
// shape change can't silently hand the preview an object.
export function enFlat(key: string): string {
  const entry = en[key];
  if (typeof entry !== 'string') {
    throw new Error(`i18n: ${key} is not a flat English entry`);
  }
  return entry;
}
